$(document).ready(function () {
	window.VegasOrder.formOrder().find('.delivery-type-radio').change(function () {
		VegasOrder.updateData();
		VegasOrder.renderPaymentsTypes();

		let val = $(this).val();

		let $cartOrder = $(this).closest('.cart-order');
		let orderId = $cartOrder.data('order-id');

		// курьер
		let $userAddress = $cartOrder.find(`input#order-${orderId}-user_address-courier`);
		if (val == 1) {
			$userAddress.attr('required', true);
		} else {
			$userAddress.attr('required', false);
		}

		// сдэк курьер
		let $userAddressCdek = $cartOrder.find(`input#order-${orderId}-user_address-courier_cdek`);
		if (val == 3) {
			$userAddressCdek.attr('required', true);
			if ($userAddressCdek.val()) $userAddressCdek.trigger('update-price')
		} else {
			$userAddressCdek.attr('required', false);
		}

		// сдэк пвз
		if (val == 4) {
			let $pvzInput = $cartOrder.find(`#order-${orderId}-user_address-cdek_pvz`);
			let pvz = $pvzInput.val();
			if (!pvz) {
				orderCdekWidget.open();
				VegasOrder.disabledCdekPvz = true;
			} else {
				$pvzInput.trigger('update-price');
			}
		}

		// boxberry пвз
		if (val == 5) {
			let $pvzInput = $cartOrder.find(`#order-${orderId}-user_address-boxberry_pvz`);
			let pvz = $pvzInput.val();
			if (!pvz) {
				BoxberryPvz.open();
				VegasOrder.disabledBoxberryPvz = true;
			} else {
				$pvzInput.trigger('update-price');
			}
		}

		let $userAddressBoxberry = $cartOrder.find(`input#order-${orderId}-user_address-courier_boxberry`);
		if (val == 6) {
			$userAddressBoxberry.attr('required', true);
			if ($userAddressBoxberry.val()) $userAddressBoxberry.trigger('update-price')
		} else {
			$userAddressBoxberry.attr('required', false);
		}

		VegasOrder.renderOrderButtons();
		VegasOrder.showOrHideFIO();
	});

	window.VegasOrder.formOrder().find('.btn-next-order').click(function () {
		let $cartOrder0 = window.VegasOrder.formOrder().find('.cart-order[data-order-id="0"]');
		let $cartOrder1 = window.VegasOrder.formOrder().find('.cart-order[data-order-id="1"]');

		let $unfilled = $cartOrder0.find('input[required]').filter(function () {
			return !$(this).val();
		});

		console.log($unfilled)

		if ($unfilled.length) {
			$unfilled.each(function () {
				$(this).closest('.form-group').addClass('has-error');
			});
			$unfilled.eq(0).focus();

			return;
		} else {
			window.VegasOrder.formOrder().find('input[required]').each(function () {
				$(this).closest('.form-group').removeClass('has-error');
			});
		}

		$(this).hide();
		window.VegasOrder.formOrder().find('.btn-make-order').show();

		$cartOrder0.slideUp('slow');
		$cartOrder1.slideDown('slow');

		let $order1 = $('.order-1-info');

		var dtype_id = $('input[name="orders[0][delivery_id]"]:checked').val();
		var dtype = $('input[name="orders[0][delivery_id]"]:checked + label > b').text();
		$order1.find('.delivery-type').find('span').text(dtype);

		let user_address = (function () {
			if (dtype_id == 1) return window.VegasOrder.formOrder().find('#user_address-courier').val();
			if (dtype_id == 2) return window.VegasOrder.formOrder().find('input[name="orders[0][store_id]"]:checked + label > b').text();
			if (dtype_id == 3) return window.VegasOrder.formOrder().find('#user_address-courier_cdek').val();
			if (dtype_id == 4) return window.VegasOrder.formOrder().find('#user_address-cdek_pvz');
			if (dtype_id == 5) return window.VegasOrder.formOrder().find('#user_address-boxberry_pvz');
			if (dtype_id == 6) return window.VegasOrder.formOrder().find('#user_address-courier_boxberry');
		})();
		$order1.find('.delivery-address').find('span').text(user_address);

		var ptype = $('input[name="orders[0][payment_id]"]:checked + label > b').text();
		$order1.find('.payment-type').find('span').text(ptype);

		var comment = $('textarea[name="orders[0][user_comment]"]').val();
		$order1.find('.comment').find('span').text(comment ? comment : '-');

		$order1.slideDown('slow');

		$('.miniorder[data-order-id="0"]').removeClass('active');
		$('.miniorder[data-order-id="1"]').addClass('active');

		$('html, body').animate({
			scrollTop: $('main').offset().top
		}, 1000);
	});

	window.VegasOrder.formOrder().find('.cart-order[data-order-id="0"] .stores input[type=radio]').change(function () {
		let val = $(this).val();
		window.VegasOrder.formOrder().find('.cart-order[data-order-id="1"] .stores input[type=radio][value="' + val + '"]')
			.prop('checked', 'checked');
	});
	window.VegasOrder.formOrder().find('.cart-order[data-order-id="0"] .delivery-type-radio').change(function () {
		let val = $(this).val();
		window.VegasOrder.formOrder().find('.cart-order[data-order-id="1"] .delivery-type-radio[value="' + val + '"]')
			.prop('checked', 'checked');
	});
	window.VegasOrder.formOrder().find('.cart-order[data-order-id="0"] .payment-type-radio').change(function () {
		let val = $(this).val();
		window.VegasOrder.formOrder().find('.cart-order[data-order-id="1"] .payment-type-radio[value="' + val + '"]')
			.prop('checked', 'checked');
	});

	window.VegasOrder.formOrder().submit(function () {
		var delivery_type = $('.delivery-type-radio:checked').val();
		var $form = $(this);

		// курьер
		if (delivery_type == 1) {
			var coordinatesFilled = $form.find('.input-coordinates').val();
			if (!coordinatesFilled) {
				alert('Пожалуйста, введите адрес');

				return false;
			}
		} else if (delivery_type == 4) {
			var addrFilled = $form.find('#user_address-cdek_pvz').val();
			if (!addrFilled) {
				alert('Пожалуйста, укажите адрес ПВЗ');

				return false;
			}
		} else if (delivery_type == 5) {
			var addrFilled = $form.find('#user_address-boxberry_pvz').val();
			if (!addrFilled) {
				alert('Пожалуйста, укажите адрес ПВЗ');

				return false;
			}
		}

		window.VegasOrder.formOrder().find(".btn-make-order").attr('disabled', 'disabled');
	});
	window.VegasOrder.formOrder().find('button[type=submit]').click(function () {
		let $invalid = window.VegasOrder.formOrder().find('input[required]:invalid').eq(0);

		if ($invalid.length) {
			$('html, body').animate({
				scrollTop: $invalid.offset().top - 200
			}, 1000);
		}

		window.VegasOrder.formOrder().addClass('was-validated');
	});
	window.VegasOrder.formOrder().on('keydown', function (e) {
		return e.key != "Enter";
	});
});